import Vue from "vue";
import App from "./App.vue";
import router from "./router";

// 引入 Bootstrap 样式
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// 引入 Bootstrap JS 和 Popper.js（用于一些交互功能）
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// 路由守卫：每次路由变化时设置页面标题
router.beforeEach((to, from, next) => {
  const pageTitle = to.meta.title
    ? `${to.meta.title} - 胖球的跑步实验室` // 如果设置了 meta.title，就拼接
    : '胖球的跑步实验室'; // 默认标题
  document.title = pageTitle; // 动态修改页面标题
  next();
});

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
